export default "/_next/static/images/2018-3x-d2a128b940390d8f498df9302cc51a5c.png";